import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import user from '../services/User'
import extraFacility from "./extra-facility";
import nicheCategory from "./niche-category";
import method from "./method";
import site from "./site";
import order from "./order";
import credit from "./credit";
import reseller from "./reseller";
import paymentSetting from "./payment-setting";
import invoice from "./invoice";
import mailTemplate from "./mail-template";
import report from "./report";
import brokenLink from "./broken-link";
import mailBox from "./mail-box";
import newsLetter from "./news-letter";
import wpAccess from "./wp-access";
import errorLog from "./error-logs";
import taskScheduler from "./task-scheduler";
import googleSheet from "./google-sheet-sync";
import client from "./client";
import siteLog from "./site-logs";
import newsletterLog from "./newsletter-logs";
import queuedJobLogs from "./queued-job-logs";
import failedQueuedLogs from "./failed-queued-logs";
import mergedInvoice from "./mergedInvoice";
import siteOwner from "./site-owner";
import siteOwnership from "./site-ownership";
import clientSummary from "./client-summary";
import cryptocurrency from "./cryptocurrency";
import logs from "./logs";
import setting from "./setting";
import clientType from "./client-type";


export default new Vuex.Store({
    modules: {
        extraFacility,
        nicheCategory,
        site,
        order,
        method,
        credit,
        reseller,
        paymentSetting,
        invoice,
        mailTemplate,
        report,
        brokenLink,
        mailBox,
        newsLetter,
        wpAccess,
        errorLog,
        taskScheduler,
        googleSheet,
        client,
        siteLog,
        newsletterLog,
        queuedJobLogs,
        failedQueuedLogs,
        mergedInvoice,
        siteOwner,
        siteOwnership,
        clientSummary,
        cryptocurrency,
        logs,
        setting,
        clientType
    },
    state: {
        snackBar: {},
        user: null,
        showLoading: false,
        users: [],
        adminUsers: [],
        allAdminUsers: [],
        dynamicWidgets: []
    },
    mutations: {
        SET_SNACKBAR: function (state, payload) {
            state.snackBar = payload
        },
        SET_USER: function (state, payload) {
            state.user = payload
        },
        SET_LOADING: function (state, payload) {
            state.showLoading = payload
        },
        SET_USERS: function (state, payload) {
            state.users = payload
        },
        SET_ADMIN_USERS: function (state, payload) {
            state.adminUsers = payload
        },
        SET_ALL_ADMIN_USERS: function (state, payload) {
            state.allAdminUsers = payload
        },
        SET_DYNAMIC_WIDGETS: function (state, payload) {
            state.dynamicWidgets = payload
        }
    },
    actions: {
        async loadUsers({commit, dispatch}, payload) {
            const {data} = await user.getUsers(payload);

            commit('SET_USERS', data);
        },
        async loadAdminUsers({commit, dispatch}, payload) {
            const {data} = await user.getAdmins(payload);

            commit('SET_ADMIN_USERS', data);
        },
        async loadAllAdminUsers({commit, dispatch}, payload) {
            const {data} = await user.getAllAdmins(payload);

            commit('SET_ALL_ADMIN_USERS', data);
        },
        async register({commit, dispatch}, payload) {
            return user.register(payload);
        },
        async updateAdmin({commit, dispatch}, payload) {
            return user.update(payload);
        },
        async updateStatus({commit, dispatch}, payload) {
            return user.updateStatus(payload);
        },
        async updateProfile({}, payload) {
            return user.updateProfile(payload);
        },
        async updatePassword({}, payload) {
            return user.updatePassword(payload);
        },
        async updateEmail({}, payload) {
            return user.updateEmail(payload);
        },
    }
})
